module.exports = __webpack_public_path__ + "img/robot_logo.0e0b90a2.svg";